module.exports = __webpack_public_path__ + "media/images/map/3-b67ed7f2c301788cfd03ac76ecca8b5d.png";